import { render } from "./MBackAlley.vue?vue&type=template&id=82979f8a&scoped=true"
import script from "./MBackAlley.vue?vue&type=script&lang=js"
export * from "./MBackAlley.vue?vue&type=script&lang=js"

import "./MBackAlley.vue?vue&type=style&index=0&id=82979f8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82979f8a"]])

export default __exports__